import React, { useEffect, useState } from "react";
import { Tabs, Tab, TabList, TabPanel } from "react-tabs";
import classnames from "classnames";
import { Link, useHistory, useLocation } from "react-router-dom";
import Copy from "@xpeng/react-copy";
import jsbridge from "@xpeng/js-bridge";
import AMap from "../../../../components/amap";
import MessageBox from "../../../../components/message-box";
import request from "../../../../network/request";
import { IReserveDetail } from "../../types";
import AmapMarker from "../components/AmapMarker";
import { reportUserBehavior } from "../../../../utils/common";
import useGetCh from "../../../../hooks/useGetCh";
import { handleSendToVehicle } from "../../../../utils/location";
// import MapSwiper from "../components/MapSwiper";
import useQuery from "../../../../hooks/useQuery";
import { ErrorPlaceholder } from "../../../../components/placeholder";
import LoadingHomepage from "../../../maintence/components/LoadingHomepage";
import ServiceProgress from "./components/serviceProgress/indexV2";
// import { isXpAPP } from "../../../../utils/common";
import moment from "moment";
import CancelOrderModal from "../../../reservationV2/components/CancelOrderModal";
// import { RESERVE_ORDER_STATUS } from '../../../reservationV2/config/constants';
import CommonLoading from "../../../../components/CommonLoading";
import CollapseContent from "./components/CollapseContent";
import { sendReport } from "../../../../utils/reporter";
import useInsuranceOverlay from "../../../reservationV2/hooks/useInsuranceOverlay";
import IssueDescriptionView from "../../../reservationV2/IssueDescriptionView";
import { hasNoiseFeedback } from "../../../reservationV2/EditingPage/hydrateCollectInfo";
import { FEE_TYPE, toFeeType } from "../../../reservationV2/config/constants";
import AttachmentUpload from "../../../../components/AttachmentUpload";
import "./index.scss";

interface IPosition {
  lng?: number | null;
  lat?: number | null;
  angle?: number | null;
}

const defaultDriverPosition = {
  lng: null,
  lat: null,
  angle: null
};

const TAB_LIST = [
  {
    id: 1,
    name: "预约信息"
  },
  {
    id: 2,
    name: "服务进度"
  }
];

// 预约单详情
export default function ReserveDetail() {
  const query = useQuery();
  const reserveId = query.get("reserveId"); //预约单id（兼容旧的传参方式）
  const reserveOrderCode = query.get("reserveOrderCode"); //预约单号（包括取车和无取车）
  const ch = useGetCh();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [orderDetail, setOrderDetail] = useState<IReserveDetail | null>(null);
  // const [mapIndex, setMapIndex] = useState(0);

  const [driverPosition, setDriverPosition] = useState<IPosition>(
    defaultDriverPosition
  );
  const [activeNavIndex, setActiveNavIndex] = useState(0);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    document.title = "预约详情";
    sendReport({
      mcode: "预约维保详情页",
      point: "P11189`B001"
    });
    // reportUserBehavior(
    //   {
    //     so: "J001002",
    //     mcode: "reserve_detail",
    //     ch,
    //     pa: `status=success`,
    //   },
    //   "page"
    // );
  }, []);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    history.listen((pre) => {
      console.log(location.pathname, pre.pathname, "路由变化");
      if (location.pathname !== pre.pathname) {
        MessageBox.removeAll();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (!loading && !error) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "reserve_detail",
          ch,
          pa: `status=success`
        },
        "page"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error]);

  const fetchReserveDetailData = async () => {
    try {
      const res: any = await request(
        "serviceOrder/getReserveDetail",
        {
          reserveUuid: reserveId || undefined,
          reserveOrderCode
        },
        "post"
      );
      setOrderDetail(res);
      if (res?.drivingDto?.isDisplayMap) {
        setDriverPosition({
          lng: res?.drivingDto?.curLng || null,
          lat: res?.drivingDto?.curLat || null,
          angle: res?.drivingDto?.angle || null
        });
      }
      window.scrollTo(0, 0);
      reportUserBehavior({
        so: "J001002",
        mcode: "reserve_detail__req_get_reserve_order_detail_success",
        ch,
        pa: `status=success\`reserveId=${reserveId}`
      });
    } catch (err) {
      reportUserBehavior({
        so: "J001002",
        mcode: "reserve_detail__req_get_reserve_order_detail_error",
        ch,
        pa: `status=error\`reserveId=${reserveId}`
      });
      setError(true);
      setErrorMsg((err as any).message || "获取预约订单失败，请稍后重试");
    }
  };

  useEffect(() => {
    getInitData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInitData = async () => {
    setLoading(true);
    setError(false);
    await fetchReserveDetailData();
    setLoading(false);
  };

  // const reloadPage = () => {
  //   // todo debugger
  //   window.location.reload();
  // }

  // tab 点击事件处理
  const onTabChangeHandler = (nav, tabIndex) => {
    setActiveNavIndex(tabIndex);
    sendReport({
      mcode: "预约信息tab点击量",
      point: tabIndex === 0 ? "P11189`B002" : "P11189`B003"
    });
  };

  if (loading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (error) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "reserve_detail",
        ch,
        pa: `status=error`
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={getInitData}
      ></ErrorPlaceholder>
    );
  }

  return (
    <div className="reserve-order-detail-wrapper">
      <Tabs
        id="custom-nav-comp"
        selectedIndex={activeNavIndex < 0 ? 0 : activeNavIndex}
        selectedTabClassName="active"
        onSelect={() => {}}
        forcerendertabspanel="true"
      >
        <TabList>
          <div className="detail-tab-list">
            {TAB_LIST.map((tabItem, tabIndex) => {
              return (
                <Tab
                  key={tabItem.id}
                  className={classnames("detail-tab-item", {
                    "selected-tab": tabIndex === activeNavIndex
                  })}
                >
                  <div
                    // className={classnames("detail-tab-item", {
                    //   'selected-tab': tabIndex === activeNavIndex,
                    // })}
                    onClick={() => onTabChangeHandler(tabItem, tabIndex)}
                  >
                    {tabItem.name}
                  </div>
                </Tab>
              );
            })}
          </div>
        </TabList>
        {TAB_LIST.map((tabItem) => {
          return (
            <TabPanel key={tabItem.id} forceRender>
              {tabItem.id === 1 && (
                <ReservationInfoPanel
                  orderDetail={orderDetail}
                  driverPosition={driverPosition}
                  onOrderCancel={() => {
                    // 刷新数据
                    getInitData();
                  }}
                />
              )}
              {tabItem.id === 2 && (
                <ServiceProgressPanel orderDetail={orderDetail} />
              )}
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
}

function ReservationInfoPanel(props) {
  const history = useHistory();
  const { orderDetail, driverPosition, onOrderCancel = () => {} } = props;
  const [showCancelModal, setShowCancelModal] = useState(false);

  // 保险资料指引覆盖层
  const { open: openInsurance, node: insuranceOverlay } = useInsuranceOverlay();
  // 问题描述只读查看覆盖层
  const [issueViewVisible, setIssueViewVisible] = useState(false);
  const ch = useGetCh();

  // 是否存在问题描述反馈——与只读页展示内容对齐：有任一维修子项反馈项，或存在异响反馈
  // （异响问题描述非必填，故不能只看 problemDesc，否则「只填了类型/位置/能否重现」的异响会在详情页丢失）
  const collect = (orderDetail as any)?.collectInfo;
  const hasIssueFeedback =
    (Array.isArray(collect?.faultFeedbackList) &&
      collect.faultFeedbackList.some((it: any) => it?.itemCode != null)) ||
    hasNoiseFeedback(collect);

  // 费用类型：读后端 collectInfo.feeType（归一化兼容数字字符串），配合 feeTypeDesc 文案展示。
  // 提交时前端只发子项 code 311/312，后端据此维护 feeType/feeTypeDesc，故详情仍用 feeType 字段。
  const feeType = toFeeType(collect?.feeType);
  const showFeeType = feeType != null && !!collect?.feeTypeDesc;

  const onCopyHandler = (e) => {
    console.log("---------------- serviceShopName --------------------");
    const target = document.querySelector("#serviceShopName");
    console.log("target >>>>>>>>>>>>>>", target);
    Copy.copy(target as any); // todo
    MessageBox.toast("复制成功");
    sendReport({
      mcode: "复制门店地址点击",
      point: "P11189`B007"
    });
  };

  const openMap = (data) => {
    const { name, lat, lot } = data;
    jsbridge.callHandler("navigate", {
      label: name,
      latitude: Number(lat),
      longitude: Number(lot)
    });

    sendReport({
      mcode: "调起地图点击",
      point: "P11189`B006"
    });
  };

  const sendAddrToCarHandler = () => {
    handleSendToVehicle(
      orderDetail?.shopAddress?.latitude,
      orderDetail?.shopAddress?.longitude,
      orderDetail?.shopAddress?.name
        ? orderDetail?.shopAddress?.name
        : orderDetail?.shopAddress?.address,
      orderDetail?.shopAddress?.address
    );

    sendReport({
      mcode: "发送地址到车点击",
      point: "P11189`B004"
    });
  };

  const handleCancel =async () => {
    const { reserveId } = orderDetail;
    CommonLoading.show();
    reportUserBehavior({
      so: "J001002",
      mcode: "reserve_order_detail__click_cancel",
      ch,
      pa: `reserveId=${reserveId}`
    });
    console.log(
      "取消预约地址",
      "module/maintenance/reserve/cancel",
      reserveId,
      "uuid < ",
      orderDetail?.reserveUuid
    );
    try{
      const res:any = await request("module/maintenance/reserve/cancel", {
          reserveUuid: orderDetail?.reserveUuid
        },
        "POST", 
        { pureReturn: true }
      )
      if (res?.code === 200) {
        MessageBox.toast("取消成功");
        reportUserBehavior({
          so: "J001002",
          mcode: "reserve_order_detail__req_cancel_success",
          ch,
          pa: `status=success\`reserveId=${reserveId}`
        });
        onOrderCancel();
        CommonLoading.hide();
      } else throw new Error(res?.msg)
    } catch (err) {
        const error = err as any;
        reportUserBehavior({
          so: "J001002",
          mcode: "reserve_order_detail__req_cancel_error",
          ch,
          pa: `status=success\`reserveId=${reserveId}`
        });
        console.error("取消预约失败:", error?.message);
        MessageBox.toast(error?.message || "取消失败");
        CommonLoading.hide();
    }
  };

  const onCancelModalConfirm = () => {
    // console.log('curSelectReserveOrderrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr');
    // onCancelReservationHandler(curSelectReserveOrder?.uuid);
    handleCancel();
    sendReport({
      mcode: "取消订单点击",
      point: "P11189`B008"
    });
  };

  const showCancelOrderModal = () => {
    setShowCancelModal(true);
  };

  const hideCancelOrderModal = () => {
    setShowCancelModal(false);
    const { reserveId } = orderDetail;
    reportUserBehavior({
      so: "J001002",
      mcode: "reserve_order_detail__click_cancel_cancel",
      ch,
      pa: `reserveId=${reserveId}`
    });
  };

  // 点击修改
  const onModifyOrderHandler = () => {
    const { reserveId, vin, reserveOrderCode } = orderDetail;
    history.push(
      `/reservation/edit/${reserveOrderCode}?reserveId=${reserveId}&ch=${ch}&vin=${vin}`
    );
    sendReport({
      mcode: "修改订单点击",
      point: "P11189`B009"
    });
  };

  return (
    <div className="order-info-container">
      {/* <div className="cell-wapper">
        <div className="cell-title">
          <h3>预约详情</h3>
        </div>
      </div> */}
      {/* 服务时间名称 */}
      <div className="cell-wapper">
        <div className="cell-title">预约车辆</div>
        <div className="cell-content">
          {orderDetail?.plateNumber
            ? orderDetail?.plateNumber
            : orderDetail?.vin}
        </div>
      </div>
      {
        // 非取送车
        !orderDetail?.drivingDto && (
          <div className="cell-wapper">
            <div className="cell-title">{orderDetail?.serviceTimeTitle}</div>
            <div className="cell-content">
              {moment(orderDetail?.serviceTime).format("YYYY/MM/DD HH:mm")}
            </div>
          </div>
        )
      }

      {orderDetail?.orderTypeText && (
        <div className="cell-wapper">
          <div className="cell-title">服务项目</div>
          <div className="cell-content">{orderDetail?.orderTypeText}</div>
        </div>
      )}

      {showFeeType && (
        <div className="cell-wapper">
          <div className="cell-title">费用类型</div>
          <div className="cell-content">{collect.feeTypeDesc}</div>
        </div>
      )}
      {feeType === FEE_TYPE.INSURANCE && (
        <div className="fee-insurance-tip">
          *保险所需资料提醒，
          <span className="link-text" onClick={openInsurance}>
            资料查看
          </span>
        </div>
      )}

      {orderDetail?.csDesc && (
        <div className="cell-wapper vertical-align-top">
          <div className="cell-title">备注</div>
          {/* <div className="cell-content collapse-content">{orderDetail.csDesc}</div> */}
          <CollapseContent contentText={orderDetail.csDesc} />
        </div>
      )}

      {/* 附件信息：只读缩略图，点击放大/播放 */}
      {Array.isArray((orderDetail as any)?.collectInfo?.attachmentList) &&
        (orderDetail as any).collectInfo.attachmentList.length > 0 && (
          <div className="attachment-cell">
            <div className="attachment-label">附件信息</div>
            <AttachmentUpload
              value={(orderDetail as any).collectInfo.attachmentList}
              readOnly
            />
          </div>
        )}

      {/* 问题描述：存在问题描述反馈时展示，点击「查看」跳只读页 */}
      {hasIssueFeedback && (
        <div className="cell-wapper">
          <div className="cell-title">问题描述</div>
          <div className="cell-content">
            <span className="link-text" onClick={() => setIssueViewVisible(true)}>
              查看
            </span>
          </div>
        </div>
      )}

      {orderDetail?.shopAddress && (
        <div className="cell-wapper">
          <div className="cell-title">预约门店</div>
          <div className="cell-content">
            {orderDetail?.shopAddress.name}
          </div>
        </div>
      )}

      <div className="shop-address-container">
        <div className={`mapInfo-container`}>
          <AMap
            initMapOptions={{
              zoom: 12,
              resizeEnable: true,
              zoomEnable: true,
              dragEnable: true
              // center: window.AMap ? new window.AMap.LngLat(orderDetail?.shopAddress?.longitude, orderDetail?.shopAddress?.latitude) : undefined,
            }}
            onInited={(amap) => {
              // amap.panBy(85, 120);
            }}
          >
            <AmapMarker
              isShopPosition={true}
              driverPosition={driverPosition}
              shopPosition={{
                lng: orderDetail?.shopAddress?.longitude || null,
                lat: orderDetail?.shopAddress?.latitude || null
              }}
              // userPosition={
              //   orderDetail?.drivingDto?.pickupLat &&
              //   orderDetail?.drivingDto?.pickupLng
              //     ? {
              //         lng: orderDetail?.drivingDto?.pickupLng || null,
              //         lat: orderDetail?.drivingDto?.pickupLat || null,
              //       }
              //     : {}
              // }
              type=""
              // type={
              //   orderDetail?.drivingDto?.pickupLat &&
              //   orderDetail?.drivingDto?.pickupLng
              //     ? "pickup"
              //     : ""
              // }
            ></AmapMarker>
          </AMap>
        </div>
        <div className="info-message">
          <div className="shop-name-field" onClick={onCopyHandler}>
            <span id="serviceShopName">{orderDetail?.shopAddress.name}</span>
            <i className="copy-icon" />
          </div>
        </div>
        <div className="actions-field">
          <div className="left-side">
            <div
              className="nav-btn"
              onClick={(e) => {
                e.stopPropagation();
                openMap({
                  name: orderDetail?.shopAddress.name,
                  lat: orderDetail?.shopAddress.latitude,
                  lot: orderDetail?.shopAddress.longitude
                });
              }}
            />
            {orderDetail?.shopAddress.telephone &&
              orderDetail?.shopAddress.telephone !== "0" && (
                <a
                  href={`tel:${orderDetail?.shopAddress.telephone}`}
                  className="info-content"
                  onClick={(e) => {
                    e.stopPropagation();
                    sendReport({
                      mcode: "联系电话点击",
                      point: "P11189`B005"
                    });
                  }}
                >
                  <div className="phone-btn" />
                </a>
              )}
          </div>
          <div className="right-side">
            <div className="send-cat-btn" onClick={sendAddrToCarHandler}>
              发送地址到车
            </div>
          </div>
        </div>
      </div>

      {
        // 取送车
        orderDetail?.drivingDto && (
          <div className="cell-wapper vertical-align-top">
            <div className="cell-title">取送车地址</div>
            {/* <div className="cell-content">
              {orderDetail.drivingDto.pickupAddress}
            </div> */}
            <CollapseContent
              contentText={orderDetail.drivingDto.pickupAddress}
              // contentText={orderDetail.csDesc}
            />
          </div>
        )
      }

      {
        // 取送车
        orderDetail?.drivingDto && (
          <div className="cell-wapper">
            <div className="cell-title">取送车时间</div>
            <div className="cell-content">
              {moment(orderDetail?.serviceTime).format("YYYY/MM/DD HH:mm")}
            </div>
          </div>
        )
      }

      {orderDetail?.reserveMan && (
        <div className="cell-wapper">
          <div className="cell-title">联系人</div>
          <div className="cell-content">
            <span className="contact-name">{orderDetail.reserveMan}</span>
          </div>
        </div>
      )}

      {orderDetail?.reserveTel && (
        <div className="cell-wapper">
          <div className="cell-title">联系电话</div>
          <div className="cell-content">
            <span className="contact-phone">{orderDetail.reserveTel}</span>
          </div>
        </div>
      )}

      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.pickDriverName && (
          <div className="cell-wapper">
            <div className="cell-title">司机姓名</div>
            <div className="cell-content">
              <span className="pick-driver-name">
                {orderDetail?.drivingDto.pickDriverName}
              </span>
            </div>
          </div>
        )}

      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.pickDriverPhone && (
          <div className="cell-wapper">
            <div className="cell-title">司机电话</div>
            <div className="cell-content">
              <a href={`tel:${orderDetail?.drivingDto?.pickDriverPhone}`}>
                {orderDetail?.drivingDto?.pickDriverPhone}
              </a>
            </div>
          </div>
        )}

      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.verifyCode && (
          <div className="cell-wapper">
            <div className="cell-title">取车验证码</div>
            <div className="cell-content">
              <span className="verify-code">
                {orderDetail?.drivingDto.verifyCode}
              </span>
            </div>
          </div>
        )}

      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.pickupPhotoList &&
        orderDetail?.drivingDto?.pickupPhotoList.length > 0 && (
          <div className="cell-wapper">
            <div className="cell-title">取车照片</div>
            <div className="cell-content">
              <Link
                to={{
                  pathname: "/serviceOrders/preview",
                  state: {
                    imgList: orderDetail?.drivingDto?.pickupPhotoList,
                    title: "取车照片"
                  }
                }}
              >
                <button
                  className="picture-view-btn"
                  onClick={() => {
                    reportUserBehavior({
                      so: "J001005",
                      mcode: "reserve_detail__click_pick_preview",
                      ch,
                      pa: ""
                    });
                  }}
                >
                  查看
                </button>
              </Link>
            </div>
          </div>
        )}

      {orderDetail?.allowCancel && (
        <div className="bottom-actions-field">
          {
            // cancelOpt
            orderDetail?.allowCancel ? (
              <div className="schedule-cancel-container">
                <div className="schedule-opt">
                  <button
                    className={classnames("cancel-schedule-btn", {
                      // "large-btn": !(orderDetail.subOrderStatus === RESERVE_ORDER_STATUS.RESERVE_SUCCESS || orderDetail.subOrderStatus === RESERVE_ORDER_STATUS.SUCCESS)
                    })}
                    // onClick={handleCancel}
                    onClick={showCancelOrderModal}
                  >
                    取消预约
                  </button>
                </div>
              </div>
            ) : null
          }
          {orderDetail?.allowCancel && (
            <div
              className={classnames("modify-reserve-btn", {
                "large-btn": !orderDetail?.allowCancel
              })}
              onClick={onModifyOrderHandler}
            >
              修改预约
            </div>
          )}
        </div>
      )}

      <CancelOrderModal
        showModal={showCancelModal}
        onConfirm={onCancelModalConfirm}
        onCancel={hideCancelOrderModal}
      />

      {/* 保险所需资料指引（复用预约流程覆盖层） */}
      {insuranceOverlay}

      {/* 问题描述只读查看（覆盖层，参考资料查看） */}
      {issueViewVisible && (
        <IssueDescriptionView
          collectInfo={collect}
          onClose={() => setIssueViewVisible(false)}
        />
      )}
    </div>
  );
}

function ServiceProgressPanel(props) {
  const { orderDetail } = props;
  // console.log('orderDetail?.serviceProgress >>>>>>>>>', orderDetail?.serviceProgress);
  return (
    <div className="service-progress-wrapper">
      {/* <h2>服务进度</h2> */}
      {orderDetail?.serviceProgress?.map((item, index) => {
        return (
          <ServiceProgress
            content={item}
            firstItem={index === 0}
            key={index}
            lastItem={index === orderDetail?.serviceProgress.length - 1}
          />
        );
      })}
    </div>
  );
}
